'use client';

import { useEffect } from 'react';
import { Button } from '@/components/ui/button';

export default function Error({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    useEffect(() => {
        console.error('[LegalPage] Error Boundary caught:', error);
    }, [error]);

    return (
        <div className="flex flex-col items-center justify-center min-h-[50vh] space-y-6 text-center px-4 py-12">
            <div className="space-y-2">
                <h2 className="text-3xl font-bold text-destructive">Something went wrong</h2>
                <p className="text-muted-foreground">We encountered an error loading this legal document.</p>
            </div>

            <div className="p-4 bg-red-50 dark:bg-red-950/20 rounded-lg text-sm font-mono text-left max-w-2xl w-full overflow-auto border border-red-200 dark:border-red-900/50 text-red-900 dark:text-red-200">
                <p className="font-semibold mb-2">Error Details:</p>
                <p className="whitespace-pre-wrap break-words">{error.message}</p>

                {error.digest && (
                    <p className="text-xs text-muted-foreground mt-4 pt-4 border-t border-red-200 dark:border-red-900/50">
                        Digest: {error.digest}
                    </p>
                )}
            </div>

            <div className="flex gap-4">
                <Button
                    onClick={() => reset()}
                    variant="default"
                >
                    Try again
                </Button>
                <Button
                    onClick={() => window.location.href = '/'}
                    variant="outline"
                >
                    Return Home
                </Button>
            </div>
        </div>
    );
}
